import ko from 'knockout/build/output/knockout-latest';

export default function () {
    //region Selectory
    const wyszukaj_mieszkanie_container = $('#wyszukaj-mieszkanie');
    const wyszukaj_mieszkanie_description_1 = $('#wyszukaj-mieszkanie-description-1');
    const wyszukaj_mieszkanie_description_2 = $('#wyszukaj-mieszkanie-description-2');
    const back_button = wyszukaj_mieszkanie_container.find('.back-button');
    const all_map_containers = wyszukaj_mieszkanie_container.find('.elevation-view, .floor-plan, .area-plan');
    const elevation_view_containers = wyszukaj_mieszkanie_container.find('.elevation-view')
    const elevation_view_container = elevation_view_containers.first();
    const multiple_buildings = elevation_view_containers.length > 1;
    const elevation_view_svg = elevation_view_container.find('.elevation-view-picture ~ svg');
    const all_elevation_view_svgs = elevation_view_containers.find('.elevation-view-picture ~ svg');
    const floor_plan_containers = wyszukaj_mieszkanie_container.find('.floor-plan');
    const floor_plan_svgs = floor_plan_containers.find('.floor-plan-picture ~svg');
    const table_container = $('#table-container');
    const tabela_mieszkania_table = $('#tabela-mieszkania');
    const showAreaPlanBtn = tabela_mieszkania_table.find('.show-area-plan-button');
    const contactModal = $('#kontakt-modal');
    //endregion Selectory

    //region Zmienne
    const pathHighlightClass = 'corresponding-row-focused';
    const rowHighlightClass = 'corresponding-path-focused';

    const AreaTypes = {
        floor: 'level-',
        area: 'area-',
        floor_plan: 'floor-plan-',
        building: 'elevation-link-',
    };

    const hide_floors = !!wyszukaj_mieszkanie_container.data('hide-floors');

    const sold_caption = '(SPRZEDANE)';
    //endregion Zmienne

    //region Modele
    const OptionModel = function (text, value) {
        this.text = text;
        this.value = value;
    };

    const MieszkanieModel = function (name, number, building, level, size, rooms, plan_url, sold, rzut_url = '', galeria_urls = [], elevation_svg = undefined, level_svg = undefined) {
        this.name = `${name}`;
        this.building = `${building}`;
        this.number = `${number}`;
        this.level = parseInt(level);
        this.size = parseFloat(size);
        this.rooms = parseInt(rooms);
        this.plan_url = plan_url;
        this.sold = !!sold;
        this.rzut_url = rzut_url;
        this.galeria_urls = galeria_urls;

        this.elevation_svg = elevation_svg;
        this.level_svg = level_svg;

        this.getAreaElement = () => {
            if (hide_floors) {
                let number_escaped = this.number.replace('.', '\\.');
                return this.elevation_svg.find(`#${AreaTypes.floor}${number_escaped}`);
            } else {
                let number_escaped = this.number.replace('.', '\\.');
                return this.level_svg.find(`#${AreaTypes.area}${number_escaped}`);
            }
        };
    };

    const TabelaMieszkanModel = function () {
        let self = this;

        let get_data_from_rendered_table = () => {
            const allAreas = [];
            const visibleAreas = [];
            const all_levels = [];
            const all_rooms = [];

            tabela_mieszkania_table.find('tbody > tr').each((idx, el) => {
                let row = $(el);
                let name = row.find('td').first().text().trim();
                let level = row.data('level');
                let building = row.data('building').toString();
                let elevation_svg = wyszukaj_mieszkanie_container.find(`.elevation-view[data-building="${building}"] .elevation-view-picture ~ svg`);
                let level_svg = wyszukaj_mieszkanie_container.find(`.floor-plan[data-building="${building}"][data-level="${level}"] .floor-plan-picture ~ svg`);
                let area = new MieszkanieModel(
                    name,
                    row.data('area'),
                    building,
                    level,
                    row.data('size'),
                    row.data('rooms'),
                    row.data('plan-url'),
                    row.data('sold'),
                    row.data('rzut-url'),
                    row.data('galeria-urls'),
                    elevation_svg,
                    level_svg
                );
                let area_el = area.getAreaElement();
                area_el.addClass(area.sold ? 'sold' : 'available');
                allAreas.push(area);
                visibleAreas.push(ko.observable(true));

                if (all_rooms.indexOf(area.rooms) === -1) {
                    all_rooms.push(area.rooms);
                }
            });
            floor_plan_containers.each((idx, el) => {
                let level = parseInt(el.dataset.level);
                if (!isNaN(level) && all_levels.indexOf(level) === -1) {
                    all_levels.push(level);
                }
            });

            const buildingsOptions = [];
            if (multiple_buildings) {
                elevation_view_containers.each((idx, el) => {
                    if (el.dataset.hideFloors) {
                        return true;
                    }
                    let id = el.id;
                    let building_string = id.slice('elevation-'.length);
                    buildingsOptions.push(new OptionModel(building_string, building_string));
                });
            }

            const levelsOptions = [];
            const level_0_caption = 'Parter';
            all_levels.sort();
            all_levels.forEach(function (level, idx) {
                levelsOptions.push(
                    new OptionModel(
                        level === 0 ? level_0_caption : level,
                        level
                    )
                );
            });

            const roomsOptions = [];
            all_rooms.sort();
            all_rooms.forEach(function (rooms, idx) {
                roomsOptions.push(
                    new OptionModel(
                        rooms,
                        rooms
                    )
                );
            });

            return {
                allAreas,
                levelsOptions,
                roomsOptions,
                visibleAreas,
                buildingsOptions,
            };
        };

        //region Values computed from pre-rendered table
        let rendered_table_data = get_data_from_rendered_table();
        this.allAreas = rendered_table_data.allAreas;
        this.visibleAreas = rendered_table_data.visibleAreas;
        //endregion

        //region Bound values
        this.levelValue = ko.observable();
        this.sizeValue = ko.observable();
        this.roomsValue = ko.observable();
        this.buildingValue = ko.observable();
        //endregion

        //region Select options etc
        this.levelsOptions = rendered_table_data.levelsOptions;
        this.sizeOptions = [
            new OptionModel('0 - 40 m.kw.', ':40'),
            new OptionModel('40 - 60 m.kw.', '40:60'),
            new OptionModel('pow. 60 m.kw.', '60:'),
        ];
        this.roomsOptions = rendered_table_data.roomsOptions;
        this.buildingsOptions = rendered_table_data.buildingsOptions;
        //endregion

        //region Functions
        this.onFilterChanged = (data) => {
            const building = data.buildingValue() !== undefined ? data.buildingValue().value : null;
            const level = data.levelValue() !== undefined ? data.levelValue().value : null;
            const rooms = data.roomsValue() !== undefined ? data.roomsValue().value : null;
            const size_more_than = data.sizeValue() !== undefined ? data.sizeValue().value.split(':')[0] : null;
            const size_less_than = data.sizeValue() !== undefined ? data.sizeValue().value.split(':')[1] : null;
            const all_areas = data.allAreas;

            if (level !== null) {
                wyszukaj_mieszkanie_description_1.hide();
                wyszukaj_mieszkanie_description_2.show();
            } else {
                wyszukaj_mieszkanie_description_1.show();
                wyszukaj_mieszkanie_description_2.hide();
            }

            all_areas.forEach((area, idx) => {
                let visible = true;
                if (building !== null && building !== area.building) {
                    visible = false;
                }
                if (level !== null && level !== area.level) {
                    visible = false;
                }
                if (rooms !== null && rooms !== area.rooms) {
                    visible = false;
                }
                if (size_more_than !== null && size_more_than !== "" && area.size < size_more_than) {
                    visible = false;
                }
                if (size_less_than !== null && size_less_than !== "" && area.size > size_less_than) {
                    visible = false;
                }
                data.visibleAreas[idx](visible);
            });

            table_container.scrollTop(0);
        };

        this.onBuildingValueChanged = (data) => {
            if (data.buildingValue() === undefined) {
                showElevation();
                //back_button.hide();
            } else {
                showElevation(data.buildingValue().value);
            }
        };

        this.onlevelValueChanged = (data) => {
            if (data.levelValue() === undefined) {
                showElevation(data.buildingValue().value);
                back_button.hide();
            } else {
                showFloorPlan(data.buildingValue().value, data.levelValue().value);
            }
        };

        this.setBuildingOption = (building) => {
            let option_to_set = undefined;
            if (building !== '') {
                self.buildingsOptions.forEach((option, idx) => {
                    if (option.value === building) {
                        option_to_set = option;
                    }
                });
            }
            self.buildingValue(option_to_set);
        };

        this.setFloorOption = (floor) => {
            let option_to_set = undefined;
            if (floor !== '') {
                self.levelsOptions.forEach((option, idx) => {
                    let parsed = parseInt(option.value);
                    if (!isNaN(parsed) && parsed === floor) option_to_set = option;
                });
            }
            self.levelValue(option_to_set);
        };

        this.getArea = (building, floor, number) => {
            for (let x = 0; x < self.allAreas.length; x++) {
                let area = self.allAreas[x];
                if (area.building === building && area.level === floor && `${area.number}` === `${number}`) {
                    return area;
                }
            }
        };
        //endregion
    };
    //endregion

    //region Knockout
    window.tabela_mieszkan_data = new TabelaMieszkanModel();
    ko.applyBindings(tabela_mieszkan_data);

    tabela_mieszkan_data.buildingValue.subscribe(() => {
        tabela_mieszkan_data.onFilterChanged(tabela_mieszkan_data);
    });
    tabela_mieszkan_data.levelValue.subscribe(() => {
        tabela_mieszkan_data.onFilterChanged(tabela_mieszkan_data);
    });
    tabela_mieszkan_data.roomsValue.subscribe(() => {
        tabela_mieszkan_data.onFilterChanged(tabela_mieszkan_data);
    });
    tabela_mieszkan_data.sizeValue.subscribe(() => {
        tabela_mieszkan_data.onFilterChanged(tabela_mieszkan_data);
    });
    //endregion

    //region Poziomy
    // if (!hide_floors) {
    //     all_elevation_view_svgs.find(`[id^="${AreaTypes.floor}"]`).each((idx, el) => {
    //         $(el).addClass('available');
    //     });
    // }

    const levelSVGsByLevelNumber = {};
    floor_plan_containers.each((idx, el) => {
        let obj = $(el);
        let level_s = obj.data('level');
        let level = parseInt(level_s);
        if (!isNaN(level)) {
            levelSVGsByLevelNumber[level] = obj.find('.floor-plan-picture ~svg');
        }
    });
    const getLevelSVG = (level) => {
        return levelSVGsByLevelNumber[level] || $();
    };
    //endregion Poziomy

    //region Show Floor / Area plan
    const showBackButton = (floor) => {
        if (floor === undefined) {
            floor = '';
        }
        back_button.data('floor', floor);
        back_button.show();
    };

    const showFloorPlan = (building_name, plan_number) => {
        let container = $(`#floor-plan-${building_name}-${plan_number}`);
        all_map_containers.hide();
        container.show();
        showBackButton();
        tabela_mieszkan_data.setFloorOption(parseInt(plan_number));
    };

    const showAreaPlan = (building_name, plan_number, floor_number) => {
        let area = tabela_mieszkan_data.getArea(building_name, floor_number, plan_number);
        if (area.plan_url || area.rzut_url || area.galeria_urls) {
            if (!hide_floors) {
                showFloorPlan(building_name, floor_number);
            }
            let opts = [];
            if (area.rzut_url) {
                let caption = (area.sold ? ` ${sold_caption} ` : '') + `Lokal ${area.number}.${area.plan_url ? ' Przesuń w bok do planu lokalu.' : ''}`;
                opts.push({
                    src: area.rzut_url,
                    opts: {
                        caption: caption,
                    },
                })
            }
            if (area.plan_url) {
                let caption = `Lokal ${area.number}.`;
                if (area.galeria_urls) {
                    caption = `${caption} Przesuń w dalej galerii.`;
                } else if (area.rzut_url) {
                    caption = `${caption} Przesuń w bok do wizualizacji.`;
                }
                if (area.sold) {
                    caption = ` ${sold_caption} ${caption}`
                }
                opts.push({
                    src: area.plan_url,
                    opts: {
                        caption: caption,
                    },
                })
            }
            if (area.galeria_urls) {
                area.galeria_urls.forEach(url => {
                    opts.push({
                        src: url,
                    })
                });
            }
            $.fancybox.open(opts);
        }
    };

    const showPlanByPrefixAndId = (prefix, path_id, building, floor_number) => {
        let plan_number = path_id.slice(prefix.length);
        if (plan_number !== null && plan_number !== "") {
            if (prefix === AreaTypes.floor) {
                showFloorPlan(building, plan_number);
            } else if (prefix === AreaTypes.area) {
                showAreaPlan(building, plan_number, floor_number);
            }
        }
    };

    const showFloorPlanByPath = (path) => {
        let elevation = path.closest('.elevation-view');
        let building = elevation.dataset.building;
        showPlanByPrefixAndId(AreaTypes.floor, path.id, building);
    };

    const showAreaPlanByPathId = (building, level, path_id) => {
        let floor_plan_number = parseInt(level);
        if (!isNaN(floor_plan_number)) {
            showPlanByPrefixAndId(AreaTypes.area, path_id, building, floor_plan_number);
        }
    };

    const showBuildingByPathId = (path_id) => {
        let building_s = path_id.slice(AreaTypes.building.length);
        showElevation(building_s);
    };

    const showElevation = (elevation) => {
        if (elevation === undefined || elevation === '') {
            all_map_containers.hide();
            elevation_view_container.show();
            tabela_mieszkan_data.setBuildingOption('');
            tabela_mieszkan_data.setFloorOption('');
        } else {
            all_map_containers.hide();
            $(`#elevation-${elevation}`).show();
            showBackButton();
            tabela_mieszkan_data.setBuildingOption(elevation);
            tabela_mieszkan_data.setFloorOption('');
        }
    };

    const highlightArea = (level, area) => {
        if (!hide_floors) {
            elevation_view_svg.find('path#' + (AreaTypes.floor + level)).addClass(pathHighlightClass);
            getLevelSVG(level).find('path#' + (AreaTypes.area + area)).addClass(pathHighlightClass);
        } else {
            elevation_view_svg.find('path#' + (AreaTypes.floor + area)).addClass(pathHighlightClass);
        }
    };

    const unHighlightActiveAreas = () => {
        elevation_view_svg.find('.' + pathHighlightClass).removeClass(pathHighlightClass);
        floor_plan_svgs.find('.' + pathHighlightClass).removeClass(pathHighlightClass);
    };

    const highlightFloorRowsByPathID = (path_id) => {
        let prefix = AreaTypes.floor;
        let floor_number_s = path_id.slice(prefix.length);
        let floor_number = parseInt(floor_number_s);
        highlightRows(undefined, floor_number);
    };
    const highlightBuildingRowsByPathID = (path_id) => {
        let prefix = AreaTypes.building;
        let building_name = path_id.slice(prefix.length);
        highlightRows(building_name);
    };
    const highlightAreaRowByPathID = (path_id) => {
        let prefix = AreaTypes.area;
        let area_number_s = path_id.slice(prefix.length);
        let area_number = (!hide_floors) ? parseInt(area_number_s) : area_number_s;
        highlightRows(undefined, undefined, area_number);
    };

    const highlightRows = (building, level, area) => {
        if (building !== undefined && building !== "") {
            tabela_mieszkania_table
                .find('tr[data-building="' + building + '"]')
                .addClass(rowHighlightClass);
            return;
        }
        if (level !== undefined && !isNaN(level)) {
            tabela_mieszkania_table
                .find('tr[data-level="' + level + '"]')
                .addClass(rowHighlightClass);
            return;
        }
        // else
        tabela_mieszkania_table
            .find('tr[data-area="' + area + '"]')
            .addClass(rowHighlightClass);
    };

    const unHighlightActiveRows = () => {
        tabela_mieszkania_table.find('.' + rowHighlightClass).removeClass(rowHighlightClass);
    };
    //endregion

    wyszukaj_mieszkanie_container.on('mouseenter', '#tabela-mieszkania tbody tr', (e) => {
        let row = $(e.currentTarget);
        let level = row.data('level');
        let area = row.data('area');
        highlightArea(level, area);
    });
    wyszukaj_mieszkanie_container.on('mouseleave', '#tabela-mieszkania tbody tr', (e) => {
        unHighlightActiveAreas();
    });

    // TODO: Instead of level-, houses should be area- if they have no floors and house- if they do
    all_elevation_view_svgs.on('mouseenter', '[id^="level-"]', (e) => {
        if (!hide_floors) {
            highlightFloorRowsByPathID(e.target.id);
        } else {
            let path_id = e.target.id.replace(AreaTypes.floor, AreaTypes.area);
            highlightAreaRowByPathID(path_id);
        }
    });
    all_elevation_view_svgs.on('mouseleave', '[id^="level-"]', () => {
        unHighlightActiveRows();
    });

    elevation_view_svg.on('mouseenter', '[id^="elevation-link-"]', (e) => {
        highlightBuildingRowsByPathID(e.target.id);
    });
    elevation_view_svg.on('mouseleave', '[id^="elevation-link-"]', () => {
        unHighlightActiveRows();
    });

    floor_plan_svgs.on('mouseenter', '[id^="area-"]', (e) => {
        highlightAreaRowByPathID(e.target.id);
    });
    floor_plan_svgs.on('mouseleave', '[id^="area-"]', () => {
        unHighlightActiveRows();
    });

    floor_plan_svgs.on('mouseenter', '[id^="area-"]', (e) => {
        highlightAreaRowByPathID(e.target.id);
    });
    floor_plan_svgs.on('mouseleave', '[id^="area-"]', () => {
        unHighlightActiveRows();
    });

    all_elevation_view_svgs.on('click', '[id^="level-"]', (e) => {
        if (!hide_floors) {
            showFloorPlanByPath(e.target);
        } else {
            let path_id = e.target.id.replace(AreaTypes.floor, AreaTypes.area);
            let elevation = e.target.closest('.elevation-view');
            let level = elevation.dataset.level ? elevation.dataset.level : '0';
            let building = elevation.dataset.building;
            showAreaPlanByPathId(building, level, path_id);
        }

    });
    all_elevation_view_svgs.on('keypress', '[id^="level-"]', (e) => {
        if (e.keyCode === 13) {
            if (!hide_floors) {
                showFloorPlanByPath(e.target);
            } else {
                let path_id = e.target.id.replace(AreaTypes.floor, AreaTypes.area);
                let elevation = e.target.closest('.elevation-view');
                let level = elevation.dataset.level ? elevation.dataset.level : '0';
                let building = elevation.dataset.building;
                showAreaPlanByPathId(building, level, path_id);
            }
        }
    });

    all_elevation_view_svgs.on('click', '[id^="elevation-link-"]', (e) => {
        showBuildingByPathId(e.target.id);
    });
    all_elevation_view_svgs.on('keypress', '[id^="elevation-link-"]', (e) => {
        if (e.keyCode === 13) {
            showBuildingByPathId(e.target.id);
        }
    });

    floor_plan_svgs.on('click', '[id^="area-"]', (e) => {
        let floor_plan = $(e.target).closest('.floor-plan');
        let level = floor_plan.data('level');
        let building = floor_plan.data('building').toString();
        showAreaPlanByPathId(building, level, e.target.id);
    });
    floor_plan_svgs.on('keypress', '[id^="area-"]', (e) => {
        if (e.keyCode === 13) {
            let floor_plan = $(e.target).closest('.floor-plan');
            let level = floor_plan.data('level');
            let building = floor_plan.data('building').toString();
            showAreaPlanByPathId(building, level, e.target.id);
        }
    });

    back_button.click((e) => {
        let btn = $(e.target);
        let floor = parseInt(tabela_mieszkan_data.levelValue() ? tabela_mieszkan_data.levelValue().value : false);
        let building = tabela_mieszkan_data.buildingValue() ? tabela_mieszkan_data.buildingValue().value : false;
        if (multiple_buildings && building && !isNaN(floor)) {
            showElevation(building);
        } else {
            showElevation();
            btn.hide();
        }
    });

    showAreaPlanBtn.click((e) => {
        let btn = $(e.target);
        let row = btn.closest('tr');
        let building = row.data('building').toString();
        let floor = row.data('level');
        let area = row.data('area');
        showAreaPlan(building, area, floor);
    });

    contactModal.on('show.bs.modal', function (e) {
        const btn = $(e.relatedTarget);
        const row = btn.closest('[data-area]');
        const lokal = row.data('area')
        const lokalInput = contactModal.find('[name="lokal"]');
        lokalInput.val(lokal);
    });

    contactModal.focusout(function (e) {
        let isInModal = $(e.relatedTarget).closest('#kontakt-modal').length > 0;
        if (!isInModal) {
            contactModal.modal('hide');
        }
    });
};
